import AngularLink from "../../../global/components/AngularLink/AngularLink.vue";
import FormElement from "../../../global/components/FormElement/FormElement.vue";
import RegistrationHeader from "../RegistrationHeader/RegistrationHeader.vue";
import PuxButton from "../../../global/components/PuxButton/PuxButton.vue";
import PuxErrors from "../../../global/components/PuxErrors/PuxErrors.vue";
import PuxPageDetails from "../../../global/components/PuxPageDetails/PuxPageDetails.vue";
import PuxRequired from "../../../global/components/PuxRequired/PuxRequired.vue";
import PuxTranslate from "../../../global/components/PuxTranslate/PuxTranslate.vue";

import HttpMixin from "../../../global/mixins/HttpMixin";

const CLASSES_HORIZONTAL = [
  "col-sm-4 text-left text-sm-right",
  "col-sm-6",
  "offset-sm-4 col-sm-6",
];

// @vue/component
export default {
  name: "ResetPasswordPage",
  components: {
    AngularLink,
    FormElement,
    RegistrationHeader,
    PuxButton,
    PuxErrors,
    PuxPageDetails,
    PuxRequired,
    PuxTranslate,
  },
  mixins: [
    HttpMixin,
  ],
  data() {
    return {
      regClass: "col-12 col-sm-10 col-lg-7 mr-0",
      statusSuccess: undefined,
      statusSubmitting: undefined,
      model: {
        email: null,
      },
      errors: {},
      optionsEmail: {
        type: "email",
        id: "email",
        label: "_LBL_RESET_PASSWORD_EMAIL_",
        placeholder: "_LBL_RESET_PASSWORD_EMAIL_",
        view: "h",
        required: true,
        classesHorizontal: CLASSES_HORIZONTAL,
      },
    };
  },
  computed: {
    optionsListForPuxErrors() {
      return [
        this.optionsEmail,
      ];
    },
  },
  methods: {
    onError(errors) {
      this.errors = errors;
    },

    sendMail() {
      if (this.statusSubmitting) {
        return;
      }
      this.deleteErrors();
      this.statusSubmitting = true;
      this.postHttp({
        url: `auth/passwort_zuruecksetzen/`,
        data: this.model,
      }).then(
        () => {
          this.statusSuccess = true;
        },
        error => {
          this.onError(error.data);
        }
      ).then(
        () => this.statusSubmitting = false
      );
    },

    deleteErrors() {
      this.errors = {};
    },
  },
};
